// The source's query-cache lifetime, for every read whose modsy query overrides
// none of RTK Query's defaults (`apiSlice.ts`): the spec reads
// (`@/hooks/specifications`), the visible divisions (`@/hooks/divisions`), the
// communities list and one community's details (`@/hooks/communities`) — and,
// with their own overrides over the top, the community search's
// `keepUnusedDataFor` and the map data's `forceRefetch` (`@/hooks/communities`),
// and the homesite reads' `forceRefetch` (`@/hooks/homesites`).
// One spelling, so two reads that behave alike in modsy cannot drift apart here.

/** RTK Query's defaults, as TanStack spells them: never stale while cached,
 *  kept 60 s once unobserved (`keepUnusedDataFor`), no focus or reconnect
 *  refetch. */
export const SOURCE_CACHE_LIFETIME = {
  staleTime: Infinity,
  gcTime: 60_000,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;
